// Frontend wrappers for team CRUD callables.

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function createTeam(
  orgId: string,
  input: { name: string; memberIds: string[] },
): Promise<{ teamId: string }> {
  const callable = httpsCallable<
    typeof input & { orgId: string },
    { teamId: string }
  >(functions, 'createTeam');
  const result = await callable({ orgId, ...input });
  return result.data;
}

export async function updateTeam(
  orgId: string,
  teamId: string,
  patch: { name?: string; memberIds?: string[] },
): Promise<void> {
  const callable = httpsCallable(functions, 'updateTeam');
  await callable({ orgId, teamId, ...patch });
}

export async function deleteTeam(
  orgId: string,
  teamId: string,
): Promise<void> {
  const callable = httpsCallable(functions, 'deleteTeam');
  await callable({ orgId, teamId });
}
